"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partToAtoms = partToAtoms;
const Kind_js_1 = require("../Kind.js");
/** @typedef {import('./partToAtoms.types').AtomsMap} AtomsMap */
/**
 * Convert a MF part to a map of atoms
 * This procedure will suppress the isotopes !
 * This is mainly used to make queries
 * @returns {AtomsMap}
 */
function partToAtoms(part) {
    /** @type {AtomsMap} */
    const atoms = {};
    for (let line of part) {
        switch (line.kind) {
            case Kind_js_1.Kind.ISOTOPE:
                if (!atoms[line.value.atom])
                    atoms[line.value.atom] = 0;
                atoms[line.value.atom] += line.multiplier;
                break;
            case Kind_js_1.Kind.ISOTOPE_RATIO:
                if (!atoms[line.value.atom])
                    atoms[line.value.atom] = 0;
                atoms[line.value.atom] += line.multiplier;
                break;
            case Kind_js_1.Kind.ATOM:
                if (!atoms[line.value])
                    atoms[line.value] = 0;
                atoms[line.value] += line.multiplier;
                break;
            case Kind_js_1.Kind.CHARGE:
                break;
            case Kind_js_1.Kind.ANCHOR:
                break;
            default:
                throw new Error('partToMF unhandled Kind: ', line.kind);
        }
    }
    return atoms;
}
//# sourceMappingURL=partToAtoms.js.map